export default [
  {
    name: 'Dashboard',
    icon: 'nc-icon nc-sound-wave',
    path: '/admin/'
  },
  {
    name: 'Orders & Quotes',
    icon: 'nc-icon nc-book-bookmark',
    children: [{
      name: 'Orders',
      path: '/admin/orders/orders'
    },{
      name: 'Quotes',
      path: '/admin/orders/quotes'
    },{
      name: 'Returns',
      path: '/admin/orders/returns'
    },{
      name: 'Configuration',
      path: '/admin/orders/configuration'
    }]
  },
  {
    name: 'Customers & Users',
    icon: 'nc-icon nc-single-02',
    children: [
        {
          name: 'Customers & Users',
          path: '/admin/users/users'
        },
        {
          name: 'Trade Applications',
          path: '/admin/users/trade-applications'
        }
    ]
  },
  {
    name: 'Products',
    icon: 'nc-icon nc-app',
    children: [{
      name: 'Categories',
      path: '/admin/products/categories'
    },
    {
      name: 'Manufacturers',
      path: '/admin/products/manufacturers'
    },
    {
      name: 'Vehicle Types',
      path: '/admin/vehicles/vehicle-types'
    },
    {
      name: 'Vehicles',
      path: '/admin/vehicles/vehicles'
    },
    {
      name: 'Assemblies',
      path: '/admin/vehicles/assemblies'
    },
    {
      name: 'Parts',
      path: '/admin/vehicles/parts'
    },
    {
      name: 'Products',
      path: '/admin/products'
    },
    {
      name: 'Blacklist',
      path: '/admin/products/blacklist'
    }
    ]
  },
  {
    name: 'Shipping',
    icon: 'nc-icon nc-box-2',
    path: '/admin/shipping'
  },
  {
    name: 'Promotions',
    icon: 'nc-icon nc-tag-content',
    path: '/admin/promotions'
  },
  {
    name: 'Blog',
    icon: 'nc-icon nc-world-2',
    path: '/admin/blog'
  },
  {
    name: 'Alerts',
    icon: 'nc-icon nc-alert-circle-i',
    path: '/admin/alerts'
  },
  {
    name: 'CMS',
    icon: 'nc-icon nc-single-copy-04',
    children: [{
      name: 'Home',
      path: '/admin/CMS/home'
    },{
      name: 'Pages',
      path: '/admin/CMS/pages'
    },{
      name: 'SEO',
      path: '/admin/CMS/SEO'
    }]
  },
  {
    name: 'Reports',
    icon: 'nc-icon nc-chart-bar-32',
    path: '/admin/reports'
  }
]
